export enum AppointmentReminderTime {
  On_Time = 0,
  Minutes_5 = 5,
  Minutes_15 = 15,
  Minutes_30 = 30,
  Days_1 = 1440,
  Days_2 = 2880,
  Days_3 = 4320,
  Weeks_1 = 10080,
  Weeks_2 = 20160,
}
